(function () {
  if (window.__HP_FULLPAGE_HERO_LOADED) return;
  window.__HP_FULLPAGE_HERO_LOADED = true;

  var SELECTOR = '[data-hp-fullpage-hero]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function HpFullpageHero(root) {
    if (!root || root.__hpHeroInit) return;
    root.__hpHeroInit = true;

    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hp-hero-slide]'));
    this.buttons = Array.prototype.slice.call(root.querySelectorAll('[data-hp-hero-button]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hp-hero-dot]'));
    this.prevBtn = root.querySelector('[data-hp-hero-prev]');
    this.nextBtn = root.querySelector('[data-hp-hero-next]');
    this.index = 0;
    this.timer = null;
    this.touchStartX = 0;
    this.touchDeltaX = 0;

    this.autoplay = root.getAttribute('data-autoplay') === 'true';
    this.speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;

    if (this.slides.length <= 1) {
      if (this.slides[0]) this.slides[0].classList.add('is-active');
      this.syncButtons(0);
      return;
    }

    this.bind();
    this.goTo(0, true);
    this.startAutoplay();
  }

  HpFullpageHero.prototype.bind = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.prev();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.next();
      });
    }

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.goTo(i);
      });
    });

    this.root.addEventListener('focusin', function () {
      self.stopAutoplay();
      self.root.classList.add('is-paused');
    });

    this.root.addEventListener('focusout', function (e) {
      if (self.root.contains(e.relatedTarget)) return;
      self.root.classList.remove('is-paused');
      self.startAutoplay();
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.prev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.next();
      }
    });

    this.root.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      self.touchStartX = e.touches[0].clientX;
      self.touchDeltaX = 0;
      self.stopAutoplay();
    }, { passive: true });

    this.root.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;
      self.touchDeltaX = e.touches[0].clientX - self.touchStartX;
    }, { passive: true });

    this.root.addEventListener('touchend', function () {
      if (Math.abs(self.touchDeltaX) > 48) {
        if (self.touchDeltaX < 0) self.next();
        else self.prev();
      }
      self.touchDeltaX = 0;
      self.startAutoplay();
    });
  };

  HpFullpageHero.prototype.syncButtons = function (index) {
    for (var b = 0; b < this.buttons.length; b++) {
      var btnIndex = parseInt(this.buttons[b].getAttribute('data-index'), 10);
      var btnActive = btnIndex === index;
      this.buttons[b].classList.toggle('is-active', btnActive);
      this.buttons[b].setAttribute('aria-hidden', btnActive ? 'false' : 'true');
      this.buttons[b].setAttribute('tabindex', btnActive ? '0' : '-1');
    }
  };

  HpFullpageHero.prototype.goTo = function (index, instant) {
    var count = this.slides.length;
    if (!count) return;

    this.index = (index + count) % count;

    for (var i = 0; i < count; i++) {
      var active = i === this.index;
      this.slides[i].classList.toggle('is-active', active);
      this.slides[i].setAttribute('aria-hidden', active ? 'false' : 'true');
    }

    for (var d = 0; d < this.dots.length; d++) {
      var isActive = d === this.index;
      this.dots[d].classList.toggle('is-active', isActive);
      this.dots[d].setAttribute('aria-current', isActive ? 'true' : 'false');
    }

    this.syncButtons(this.index);

    if (!instant) this.restartAutoplay();
  };

  HpFullpageHero.prototype.next = function () {
    this.goTo(this.index + 1);
  };

  HpFullpageHero.prototype.prev = function () {
    this.goTo(this.index - 1);
  };

  HpFullpageHero.prototype.startAutoplay = function () {
    var self = this;
    if (!this.autoplay || prefersReducedMotion() || this.slides.length <= 1) return;
    this.stopAutoplay();
    this.timer = window.setInterval(function () {
      self.next();
    }, this.speed);
  };

  HpFullpageHero.prototype.stopAutoplay = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  HpFullpageHero.prototype.restartAutoplay = function () {
    this.stopAutoplay();
    this.startAutoplay();
  };

  HpFullpageHero.prototype.destroy = function () {
    this.stopAutoplay();
    this.root.__hpHeroInit = false;
  };

  function initHero(root) {
    if (!root) return;
    if (root.__hpHeroInstance) {
      root.__hpHeroInstance.destroy();
    }
    root.__hpHeroInstance = new HpFullpageHero(root);
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var nodes = context.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      initHero(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var nodes = event.target.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].__hpHeroInstance) {
        nodes[i].__hpHeroInstance.destroy();
        nodes[i].__hpHeroInstance = null;
      }
      nodes[i].__hpHeroInit = false;
    }
  });
})();
